import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=551a815a&scoped=true&"
import script from "./Brand.vue?vue&type=script&lang=js&"
export * from "./Brand.vue?vue&type=script&lang=js&"
import style0 from "./Brand.vue?vue&type=style&index=0&id=551a815a&prod&lang=scss&scoped=true&"
import style1 from "./Brand.vue?vue&type=style&index=1&id=551a815a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a815a",
  null
  
)

export default component.exports